import { useMemo, useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import createAddAthleteSchema from "../schemas/addAthleteSchema";

import AddAthleteInput from "./AddAthleteInput";
import Button from "../../../components/Button";

import { addAthlete } from "../api/athleteRequests";
import { useTranslation } from "../../../i18n/TranslationProvider";

const AddAthleteForm = ({ userId }) => {
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const { t } = useTranslation();

    const addAthleteSchema = useMemo(() => createAddAthleteSchema(t), [t]);

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
        reset,
    } = useForm({
        resolver: yupResolver(addAthleteSchema),
    });

    const clearMessages = () => {
        if (message || error) {
            setMessage("");
            setError("");
        }
    };

    const onSubmit = async (data) => {
        const athlete = data.athletes[0];
        const payload = { ...athlete, userId };

        try {
            const res = await addAthlete(payload);
            setError("");
            setMessage(
    //            `Athlete ${res.data.first_name} has been added to the roster!`
                  t("athletes.addAthleteSuccess")
            );
            reset();
        } catch (err) {
            console.error("Add athlete onSubmit error:", err);
            setMessage("");
            setError(
                err.response?.data?.error ||
                    t("athletes.addAthleteErrorGeneric")
            );
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} onInput={clearMessages}>
            <AddAthleteInput index={0} register={register} errors={errors} />
            {error && <p className="text-red-600 mb-2">{error}</p>}
            {message && <p className="text-teal-600 mb-4">{message}</p>}
            <Button type="submit" isLoading={isSubmitting} className="w-full">
                {t("athletes.addAthleteButton")}
            </Button>
        </form>
    );
};

export default AddAthleteForm;